<template>
    <div class="headBox">
        <el-form ref="form" :model="form" label-width="150px">
            <el-row align="middle" v-if="moreSearchItem">
                <el-row align="middle">
                    <el-col>
                        <el-form-item label="项目状态：">
                            <div v-if="systemType=='GC'||systemType=='CG'">
                                <span
                                    v-for="(item,i) in projectStatusList"
                                    :key="i"
                                    class="screen_btn"
                                    @click="projectStatusHandle(item.value,1)"
                                    :class="item.value==form.projectStatus?'check':null"
                                >{{item.name}}</span>
                            </div>
                            <div v-if="systemType=='CQ'||systemType=='GT'">
                                <span
                                    v-for="(item,i) in projectStatusList1"
                                    :key="i"
                                    class="screen_btn"
                                    @click="projectStatusHandle(item.value,1)"
                                    :class="item.value==form.projectStatus?'check':null"
                                >{{item.name}}</span>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row align="middle">
                    <el-col>
                        <el-form-item label="项目类型：">
                            <div>
                                <span
                                    v-for="(item,i) in projectTypeList"
                                    :key="i"
                                    class="screen_btn"
                                    @click="projectStatusHandle(item.value,2)"
                                    :class="item.value==form.projectType?'check':null"
                                >{{item.name}}</span>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-row align="middle">
                        <el-col :span="7" v-if="moreSearchItem">
                            <el-form-item label="年份：">
                                <el-select
                                    v-model="form.bidYear"
                                    value-key="value"
                                    style="width:100%;"
                                    @change="yearsChange"
                                >
                                    <el-option
                                        v-for="(item,index) in yearsList"
                                        :key="index"
                                        :label="item"
                                        :value="item"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7" v-if="moreSearchItem">
                            <el-form-item label="招标代理机构：">
                                <el-input
                                    v-model="form.tenderAgencyName"
                                    clearable
                                    placeholder="请输入内容搜索"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7" v-if="moreSearchItem">
                            <el-form-item label="交易中心：">
                                <el-select
                                    v-model="form.tradeId"
                                    clearable
                                    value-key="value"
                                    style="width:100%;"
                                >
                                    <el-option label="全部" value></el-option>
                                    <el-option
                                        v-for="(item,index) in transactionCenterList"
                                        :key="index"
                                        :label="item.orgName"
                                        :value="item.id"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!-- <el-row align="middle">
                    <el-col :span="7" v-if="moreSearchItem">
                        <el-form-item
                            :label="businessType|typeMapperProjectNameDesc"
                            props="projectName"
                        >
                            <el-input
                                v-model="form.tenderProjectName"
                                clearable
                                placeholder="请输入内容搜索"
                                @keyup.enter.native="seachBtn"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7"  v-if="moreSearchItem">
                        <el-form-item
                            :label="businessType|typeMapperProjectCodeDesc"
                            props="projectCode"
                        >
                            <el-input
                                v-model="form.tenderProjectCode"
                                clearable
                                placeholder="请输入内容搜索"
                                @keyup.enter.native="seachBtn"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8"  v-if="moreSearchItem">
                        <el-form-item :label="businessType|typeMapperBidAngle1">
                            <el-input
                                v-model="form.tendererName"
                                clearable
                                placeholder="请输入内容搜索"
                                @keyup.enter.native="seachBtn"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    </el-row>-->
                    <el-row align="middle">
                        <el-col :span="7">
                            <el-form-item label="开标时间：">
                                <el-date-picker
                                    v-model="projecBidOpenTime"
                                    @change="(val)=>projecBidOpenTimeHandle(val,1)"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd"
                                    style="width:100%;"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item label="中标结果公告时间：">
                                <el-date-picker
                                    v-model="projecBuyprojectresultnoticeTime"
                                    @change="(val)=>projecBidOpenTimeHandle(val,2)"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd"
                                    style="width:100%;"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-row>
                                <el-col :span="17">
                                    <el-form-item label="登记起止时间：">
                                        <el-date-picker
                                            style="width: 100%"
                                            v-model="datetimerange"
                                            type="datetimerange"
                                            format="yyyy-MM-dd HH:mm:ss"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            range-separator="至"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期"
                                            @change="(val)=>projecBidOpenTimeHandle(val,3)"
                                        ></el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="5">
                                    <el-form-item label-width="20px">
                                        <el-button
                                            size="small"
                                            type="primary"
                                            @click="seachBtn"
                                        >搜索</el-button>
                                        <el-button
                                            plain
                                            size="small"
                                            type="primary"
                                            style="margin-left:10px;"
                                            @click="reflash"
                                        >重置</el-button>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                </el-row>
            </el-row>
        </el-form>
    </div>
</template>
  
  <script>
import emptyInfo from "@/components/empty-info";
import { nearSixYearsList } from "@/utils/index";
import { removeTabHandle } from "@/utils/routeTab";
export default {
    name: "busWitnessTable",
    components: {
        emptyInfo
    },
    data() {
        return {
            tableMaxHeight: document.documentElement.clientHeight - 236,
            dataListLoading: false,
            yearsList: [],
            datetimerange: [],
            form: {
                bidYear: new Date().getFullYear(),
                bidSectionName: "", // 标段名称
                bidSectionCode: "", // 标段编号
                tenderProjectCode: "", // 招标项目编号
                tenderProjectName: "", // 所属招标项目
                tendererName: "", // 投标人
                tenderAgencyName: "", // 招标代理结构
                createTimeGE: "", // 登记开始时间
                createTimeLT: "", // 登记结束时间
                tradeId: "", // 交易中心ID
                projectStatus: "", // 项目状态
                projectType: "", // 项目类型
                bidOpenStartTime: "", // 开标时间
                bidOpenEndTime: "",
                buyprojectresultnoticeTimeStart: "", //开评标结果公示
                buyprojectresultnoticeTimeEnd: ""
            },
            deleteBtnShow: false,
            selectDeleteList: [],
            businessType: "",
            groupMark: "",
            witnessModlist: [],
            witnessStatuslist: [],
            flownodesListData: [],
            moreSearchItem: false,
            checkList1: "",
            pageSize: 10, //每页条数
            pageIndex: 1, //当前页
            total: 0, //总条数
            tableData: [],
            multipleSelection: [],
            user: "", //角色类型
            formData: {},
            transactionCenterList: [],
            systemType: "GC",
            // 项目跟踪-工程建设和政府采购
            projectStatusList: [
                { name: "全部", value: "" },
                { name: "未开标", value: "1" },
                { name: "已开标（未完结）", value: "2" },
                { name: "已正常完结", value: "3" },
                { name: "招标异常", value: "4" }
            ],
            // 项目跟踪-国有产权和国土交易
            projectStatusList1: [
                { name: "全部", value: "" },
                { name: "待竞价", value: "1" },
                { name: "自由竞价中", value: "2" },
                { name: "限时竞价中", value: "3" },
                { name: "已完结", value: "4" },
                { name: "招标异常", value: "5" }
            ],
            projectTypeList: [],
            projecBidOpenTime: null, //开标时间
            projecBuyprojectresultnoticeTime: null, //中标结果时间
            projecEntryTime: null, //限时竞价时间
            projecBuyprojectresultnoticeTime1: null //中标结果公告时间
        };
    },

    props: {
        busWitnessTableType: {
            type: String,
            default: ""
        },
        showMore: {
            type: Boolean,
            default: false
        }
    },
    filters: {
        ellipsis(text, num) {
            if (text.length > num) {
                return text.substring(0, num) + "...";
            } else {
                return text;
            }
        },

        typeMapperBidNameDesc: function(type) {
            switch (type) {
                case "GC":
                    return "标段名称：";
                    break;
                case "CG":
                    return "包件名称：";
                    break;
                case "CQ":
                    return "标的名称：";
                    break;
                case "GT":
                    return "标的名称：";
                    break;
                case "QT":
                    return "标的名称：";
                    break;
                default:
                    return "标的名称：";
                    break;
            }
        },
        typeMapperBidCodeDesc: function(type) {
            switch (type) {
                case "GC":
                    return "标段编号：";
                    break;
                case "CG":
                    return "包件编号：";
                    break;
                case "CQ":
                    return "标的编号：";
                    break;
                case "GT":
                    return "标的编号：";
                    break;
                case "QT":
                    return "所属项目编号：";
                    break;
                default:
                    return "所属项目编号：";
                    break;
            }
        },
        typeMapperProjectNameDesc: function(type) {
            switch (type) {
                case "GC":
                    return "招标项目名称：";
                    break;
                case "CG":
                    return "采购项目名称：";
                    break;
                case "CQ":
                    return "项目名称：";
                    break;
                case "GT":
                    return "项目名称：";
                    break;
                case "QT":
                    return "项目名称：";
                    break;
                default:
                    return "项目名称：";
                    break;
            }
        },
        typeMapperProjectCodeDesc: function(type) {
            switch (type) {
                case "GC":
                    return "招标项目编号：";
                    break;
                case "CG":
                    return "采购项目编号：";
                    break;
                case "CQ":
                    return "项目编号：";
                    break;
                case "GT":
                    return "项目编号：";
                    break;
                case "QT":
                    return "项目编号：";
                    break;
                default:
                    return "项目编号：";
                    break;
            }
        },
        typeMapperProjectAngle: function(type) {
            switch (type) {
                case "GC":
                    return "项目（标段）视角";
                    break;
                case "CG":
                    return "项目（包件）视角";
                    break;
                case "CQ":
                    return "项目（标段）视角";
                    break;
                case "GT":
                    return "项目（标段）视角";
                    break;
                case "QT":
                    return "项目（标段）视角";
                    break;
                default:
                    return "项目（标段）视角";
                    break;
            }
        },
        typeMapperBidAngle: function(type) {
            switch (type) {
                case "GC":
                    return "招标人";
                    break;
                case "CG":
                    return "采购人";
                    break;
                case "CQ":
                    return "招标人";
                    break;
                case "GT":
                    return "招标人";
                    break;
                case "QT":
                    return "招标人";
                    break;
                default:
                    return "招标人";
                    break;
            }
        },
        typeMapperBidAngle1: function(type) {
            switch (type) {
                case "GC":
                    return "招标人：";
                    break;
                case "CG":
                    return "采购人：";
                    break;
                case "CQ":
                    return "招标人：";
                    break;
                case "GT":
                    return "招标人：";
                    break;
                case "QT":
                    return "招标人：";
                    break;
                default:
                    return "招标人：";
                    break;
            }
        }
    },
    activated() {
        this.businessType =
            this.busWitnessTableType ||
            window.sessionStorage.getItem("witnessHisBusinessType");
        // this.getDataList();
        // this.reflash();
    },
    created() {
        this.businessType =
            this.busWitnessTableType ||
            window.sessionStorage.getItem("witnessHisBusinessType");
        // this.getDic("jz_dgwitness_witness_mod");
        // this.getDic("jz_dgwitness_witness_status");
        this.getDic("146");
        this.yearsList = nearSixYearsList(this.form.bidYear);
        this.transactionCenterList = JSON.parse(
            sessionStorage.getItem("transactionCenterList")
        );
    },
    watch: {
        showMore: {
            immediate: true,
            handler(val) {
                this.moreSearchItem = val;
            }
        }
    },
    mounted() {
        const that = this;
        let resizeTag = true;
        window.onresize = () => {
            if (resizeTag) {
                //防抖动
                that.ifmove();
                resizeTag = false;
                setTimeout(() => {
                    resizeTag = true;
                }, 1000);
            }
        };
        that.ifmove();
    },
    methods: {
        // 项目跟踪-项目状态
        projectStatusHandle(value, type) {
            //type: 1代表项目状态（projectStatus）2 代表项目类型（projectType）
            if (type == 1) {
                this.form.projectStatus = value;
            } else {
                this.form.projectType = value;
            }
        },
        // 选择时间change事件
        projecBidOpenTimeHandle(value, flag) {
            // flag 1开标时间 2开中标结果公告时间 3//登记起止时间：
            switch (flag) {
                case 1:
                    if (value) {
                        this.form.bidOpenStartTime = value[0] ? value[0] : "";
                        this.form.bidOpenEndTime = value[1] ? value[1] : "";
                    } else {
                        this.form.bidOpenStartTime = "";
                        this.form.bidOpenEndTime = "";
                    }
                    break;
                case 2:
                    if (value) {
                        this.form.buyprojectresultnoticeTimeStart = value[0]
                            ? value[0]
                            : "";
                        this.form.buyprojectresultnoticeTimeEnd = value[1]
                            ? value[1]
                            : "";
                    } else {
                        this.form.buyprojectresultnoticeTimeStart = "";
                        this.form.buyprojectresultnoticeTimeEnd = "";
                    }
                    break;
                case 3:
                    if (value) {
                        this.form.createTimeGE = value[0] ? value[0] : "";
                        this.form.createTimeLT = value[1] ? value[1] : "";
                    } else {
                        this.form.createTimeGE = "";
                        this.form.createTimeLT = "";
                    }
                    break;
                default:
                    break;
            }
        },
        ifmove() {
            this.tableMaxHeight =
                document.documentElement.clientHeight - 236 + "px";
            this.pageIndex = 1;
            if (document.documentElement.clientHeight > 900) {
                this.pageSize = 16;
            } else if (document.documentElement.clientHeight < 770) {
                this.pageSize = 8;
            } else {
                this.pageSize = 12;
            }
            // this.getDataList()
        },
        yearsChange(val) {
            this.yearsList = nearSixYearsList(val);
            // this.getDataList();
        },
        businessTypeFormat(type) {
            switch (type) {
                case "GC":
                    return "工程建设";
                    break;
                case "CG":
                    return "政府采购";
                    break;
                case "CQ":
                    return "产权交易";
                    break;
                case "GT":
                    return "国土交易";
                    break;
                case "QT":
                    return "其他";
                    break;
                default:
                    return "其他";
                    break;
            }
        },
        // getDataList(parentKey) {
        //     // 获取列表数据
        //     this.form.createTimeGE = this.datetimerange[0]
        //         ? this.datetimerange[0]
        //         : "";
        //     this.form.createTimeLT = this.datetimerange[1]
        //         ? this.datetimerange[1]
        //         : "";
        //     this.form.busType = this.businessType;
        //     this.dataListLoading = true;
        //     this.$http
        //         .post("/bidSection/listProjectFlowPaged", {
        //             page: this.pageIndex,
        //             rows: this.pageSize,
        //             searchKey: parentKey?parentKey:'',
        //             filter: this.form
        //         })
        //         .then(res => {
        //             this.dataListLoading = false;
        //             this.tableData = res.data.data.rows;
        //             this.total = res.data.data.total;
        //         });
        // },
        getDic(type) {
            // 获取字典
            this.$http.get("/sys/dictData/getList?type=" + type).then(res => {
                if (res.data.code === "1") {
                    switch (type) {
                        case "jz_dgwitness_witness_mod":
                            this.witnessModlist = res.data.data;
                            break;
                        case "jz_dgwitness_witness_status":
                            this.witnessStatuslist = res.data.data;
                            break;
                        case "146":
                            this.projectTypeList = res.data.data||[];
                            this.projectTypeList.unshift({
                                name: "全部",
                                value: ""
                            });
                            break;
                    }
                }
            });
        },
        //搜索按钮
        seachBtn(parentSearchKey) {
            this.pageIndex = 1;
            // this.getDataList(parentSearchKey);
            this.form.busType = this.businessType;
            // 把值传回父级
            this.$emit("seachBtn");
        },
        reflash() {
            //刷新按钮
            this.pageIndex = 1;
            this.$refs["form"].resetFields();
            // 重置时间选择器
            this.datetimerange = [];
            this.projecBuyprojectresultnoticeTime = null;
            this.projecBidOpenTime = null;
            this.form = {
                bidYear: new Date().getFullYear(),
                bidSectionName: "", // 标段名称
                bidSectionCode: "", // 标段编号
                tenderProjectCode: "", // 招标项目编号
                tenderProjectName: "", // 所属招标项目
                tendererName: "", // 投标人
                tenderAgencyName: "", // 招标代理结构
                createTimeGE: "", // 登记开始时间
                createTimeLT: "", // 登记结束时间
                projectStatus: "", // 项目状态
                projectType: "", // 项目类型
                bidOpenStartTime: "", // 开标时间
                bidOpenEndTime: "",
                buyprojectresultnoticeTimeStart: "", //开评标结果公示
                buyprojectresultnoticeTimeEnd: ""
            };
            this.yearsList = nearSixYearsList(this.form.bidYear);
            // 把值传回父级 重置时把父级searchkey也清空
            this.$emit("seachBtn", 1);
        }
    },
    destroyed() {
        window.onresize = null;
    }
};
</script>

  <style lang="less" scoped>
.projectCard {
    position: relative;
    overflow: inherit;
    padding: 0;
    margin-bottom: 15px;
    /deep/ .el-card__body {
        padding: 0;
    }
    /deep/ .el-card__header {
        padding: 16px 16px 0px 16px;
    }

    .title {
        width: calc(100% - 10px);
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}

//列表页面
.top {
    .seachbtn {
        margin-left: 100px;
        display: flex;
    }
}
.screen_btn {
    cursor: pointer;
    padding: 7px 15px;
    margin-right: 10px;
    border-radius: 5px;
}
.check {
    background: @--color-primary;
    color: #ffffff;
}
</style>
  